import { Component, OnInit, Inject } from '@angular/core';
import { TransferenciaService } from 'app/main/financial/services/transferencia/transferencia.service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { MessageDialogComponent } from '../../components/message-dialog/message-dialog.component';
import { fuseAnimations } from '@fuse/animations';

@Component({
  selector: 'app-desvincular-contrato',
  templateUrl: './desvincular-contrato.component.html',
  styleUrls: ['./desvincular-contrato.component.scss'],
  animations: fuseAnimations
})
export class DesvincularContratoComponent implements OnInit {

  confirmation : any;
  dialogRef : any;
  titulo: string;
  disabledButton:boolean;


  constructor(@Inject(MAT_DIALOG_DATA) public data : any,
              private matDialogRef : MatDialogRef<DesvincularContratoComponent>,
              private _matDialog : MatDialog) { 

              this.confirmation = data;
  }

  ngOnInit() : void {
    
  }

  desvincularContrato(){
    this.disabledButton = true;
    this.matDialogRef.close(this.confirmation.contrato);
  }
  
  onCancel(): void {
    this.matDialogRef.close();
  }
}